import React, { useMemo } from "react";
import { Box, Stack, Tab, Tabs, useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useLocation, useNavigate } from "react-router-dom";

import Sidebar from "./AccountTabsContent/Sidebar";
import BasicTab from "./AccountTabsContent/BasicTab";
import DashboardTab from "./AccountTabsContent/DashboardTab";
import { tForLang } from "./AccountUtils";

export default function AccountTabs({ tab, lang, user, onUserUpdated }) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const navigate = useNavigate();
  const location = useLocation();

  const t = (key) => tForLang(lang, key);

  const mobileTabs = useMemo(
    () => [
      { value: "dashboard", label: t("memberArea") },
      { value: "basic", label: t("basicInfo") },
    ],
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [lang]
  );

  const currentMobileValue = useMemo(() => tab || "dashboard", [tab]);

  const handleMobileTabChange = (_e, newValue) => {
    const target = mobileTabs.find((x) => x.value === newValue);
    if (!target) return;

    const search = new URLSearchParams(location.search);
    search.set("tab", newValue);
    navigate(`${location.pathname}?${search.toString()}`, { replace: true });
  };

  return (
    <>
      {isMobile && (
        <Tabs
          value={currentMobileValue}
          onChange={handleMobileTabChange}
          variant="scrollable"
          allowScrollButtonsMobile
          scrollButtons="auto"
          sx={{
            mb: 2,
            borderBottom: "1px solid",
            borderColor: "divider",
            "& .MuiTab-root": { fontWeight: 700, fontSize: 14, minHeight: 40, px: 1.25 },
            "& .MuiTabs-indicator": { height: 3 },
          }}
        >
          {mobileTabs.map((tItem) => (
            <Tab key={tItem.value} label={tItem.label} value={tItem.value} />
          ))}
        </Tabs>
      )}

      <Stack direction="row" spacing={2} alignItems="flex-start">
        <Box sx={{ width: { xs: 0, md: 260 }, display: { xs: "none", md: "block" } }}>
          <Sidebar lang={lang} />
        </Box>

        <Box sx={{ flex: 1 }}>
          {tab === "basic" && <BasicTab user={user} lang={lang} onUserUpdated={onUserUpdated} />}
          {(tab === "dashboard" || !tab) && <DashboardTab user={user} lang={lang} />}
        </Box>
      </Stack>
    </>
  );
}
